import { render, staticRenderFns } from "./AdminMcpTokens.vue?vue&type=template&id=65dbd072&"
import script from "./AdminMcpTokens.vue?vue&type=script&lang=js&"
export * from "./AdminMcpTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports